import { useState } from 'react'
import { toast } from '@ideon-api/ideon-ui'
import { downloadCsv } from './download-csv'
import { sdkErrorMessage, useAccessToken } from './sdk-client'

// By fetch, not the SDK: the endpoints return CSV, which the generated client cannot download.
export function useCsvExport<Args extends unknown[]>(
  request: (token: string, ...args: Args) => Promise<Response>,
  filename: string,
  fallbackMessage: string,
) {
  const getToken = useAccessToken()
  const [exporting, setExporting] = useState(false)

  const exportCsv = async (...args: Args) => {
    setExporting(true)
    try {
      await downloadCsv(await request(await getToken(), ...args), filename)
    } catch (error) {
      toast({ title: 'Export failed', description: sdkErrorMessage(error, fallbackMessage) })
    } finally {
      setExporting(false)
    }
  }

  return { exportCsv, exporting }
}
